import React from "react";
import { List, Popconfirm, message, Skeleton, Divider, Button, Icon, Empty } from "antd";
import axios from "axios";
import { withTranslation } from 'react-i18next';
import ContactForm from '../Contacts/ContactForm';


class LeadFormContactSidebar extends React.Component {
    state = ({
        modalContact: {},
        modalRequestType: '',
        // modalLoading: true,
        modalBtnText: "",
        modalVisible: false,
        modalTitleText: "",
        contacts: [],
    });

    handleState = (key, value) => {
        let obj = {};
        obj[key] = value;
        this.setState(obj);
    }


    handleDelete(contactID) {
        axios.delete(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/delete/`)
            .then(res => {
                if (res.status === 204 || res.status === 200) {
                    const data = this.props.lead.contacts;
                    const data_fixed = data.filter(item => item.id !== contactID);
                    let new_data = this.props.lead;
                    new_data.contacts = data_fixed;
                    this.props.handleState('lead', new_data);
                    this.props.handleState('data', data_fixed);
                    message.success(this.props.t('contacts.contact_list.contact_deleted', "Contact deleted"));
                } else {
                    message.warning(this.props.t('contacts.contact_list.contact_deletion_failed', "Deletion failed"));
                }
            })
    };

    confirmDelete(event, contactID) {
        event.preventDefault();
        this.handleDelete(contactID);
    }

    showModal = () => {
        this.formRef.resetFields();
        this.setState({
            modalVisible: true,
            modalTitleText: this.props.t('contacts.contact_list.modal_title_create', "Create a new contact"),
            modalRequestType: "post",
            modalBtnText: this.props.t('general.create', "Create"),
            modalContact: {},
        });
    };

    hideModal = () => {
        this.setState({
            modalVisible: false,
        });
    };

    handleCreate = () => {
        this.formRef.validateFields((err, values) => {
            if (err) {
                return;
            }

            let postObj = {
                ...values
            }
            postObj['leads'] = this.props.lead.id;

            this.hideModal();
            axios.post(process.env.REACT_APP_AXIOS_URL + "/api/contacts/create/", postObj)
                .then(res => {
                    if (res.status === 201) {
                        this.props.fetch();
                        message.success(this.props.t('contacts.contact_list.contact_created', "Contact created successfully"));
                    }
                })

            this.formRef.resetFields();
        });
    };

    handlePreview = event => {
        const contactID = event.currentTarget.getAttribute('data-contact_id');
        this.formRef.resetFields();
        axios.get(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/`)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        modalContact: res.data,
                        // modalLoading: false,
                        modalBtnText: undefined,
                        modalVisible: true,
                        modalRequestType: "get",
                        modalTitleText: this.props.t('contacts.contact_list.modal_title_preview', "Previewing a contact")
                    });
                } else {
                    this.props.history.push('/contacts');
                }
            })
    };

    handleEditPreview = event => {
        const contactID = event.currentTarget.getAttribute('data-contact_id');
        this.formRef.resetFields();
        axios.get(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/`)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        modalContact: res.data,
                        // modalLoading: false,
                        modalBtnText: this.props.t('general.update', "Update"),
                        modalVisible: true,
                        modalRequestType: "put",
                        modalTitleText: this.props.t('contacts.contact_list.modal_title_update', "Update contact")
                    });
                } else {
                    this.props.history.push('/contacts');
                }
            })
    };

    handleEdit = event => {
        this.formRef.validateFields((err, values) => {
            if (err) {
                return;
            }

            const postObj = {
                ...values
            }
            const contactID = this.state.modalContact.id;
            this.hideModal();
            axios.put(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/update/`, postObj)
                .then(res => {
                    if (res.status === 200) {
                        this.props.fetch();
                        message.success(this.props.t('contacts.contact_list.contact_updated', "Contact have been updated"));
                    }
                })

            // this.formRef.resetFields();
        });
    };


    render() {
        const { contacts, t } = this.props;

        if (this.props.loading) {
            return (
                <div>
                    <Skeleton active loading={this.props.loading} />
                    <Skeleton active loading={this.props.loading} />
                    <Skeleton active loading={this.props.loading} />
                    <Skeleton active loading={this.props.loading} />
                    <Skeleton active loading={this.props.loading} />
                </div>
            );
        } else {
            return (
                <div>
                    <Button style={{ borderRadius: '0px' }} type="dashed" onClick={this.showModal}>
                        <Icon type="plus" />
                        {t('general.create', "Create")}
                    </Button>
                    {
                        contacts && contacts.length > 0 ?
                            <List
                                itemLayout="horizontal"
                                dataSource={contacts}
                                renderItem={contact => (
                                    <List.Item>
                                        <List.Item.Meta
                                            // avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
                                            title={contact.first_name}
                                            description={
                                                <div>
                                                    <a onClick={this.handlePreview} data-contact_id={contact.id} key="contact=list-view">View</a> <Divider type="vertical" />
                                                    <a onClick={this.handleEditPreview} data-contact_id={contact.id} key="contact-list-edit">Edit</a> <Divider type="vertical" />
                                                    <Popconfirm
                                                        title={t('contacts.contact_list.contact_delete', "Are you sure want to delete this contact?")}
                                                        onConfirm={(event) => {
                                                            this.confirmDelete(event, contact.id);
                                                        }}
                                                        okText={t('general.yes', "Yes")}
                                                        cancelText={t('general.no', "No")}
                                                        className='data-id={contact.id}'
                                                    >
                                                        <a key="contact-list-delete" href="#">{t('general.delete', "Delete")}</a>
                                                    </Popconfirm><br>
                                                    </br>
                                                    {contact.description}
                                                </div>
                                            }
                                        />
                                    </List.Item>
                                )}
                            /> :
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    }
                    <ContactForm
                        wrappedComponentRef={(form) => this.formRef = form}
                        visible={this.state.modalVisible}
                        onCancel={this.hideModal}
                        btnText={this.state.modalBtnText}
                        titleText={this.state.modalTitleText}
                        handleState={this.handleState}
                        requestType={this.state.modalRequestType}
                        data={this.state.modalContact}
                        fetch={this.props.fetch}
                        contacts={this.props.contacts}
                        lead={this.props.lead}
                    />
                </div>
            );
        }
    }
}

export default withTranslation()(LeadFormContactSidebar);


// WEBPACK FOOTER //
// ./src/containers/Leads/LeadFormContactSidebar.js